import React, {Component} from 'react';
import PropTypes from 'prop-types';
import css from './usersTable.scss';

class Table extends Component {
	render() {
		return <div className={css.table}>{this.props.children}</div>;
	}
}
class Row extends Component {
	static propTypes = {
		head: PropTypes.bool,
	};
	classes = [
		this.props.head && 'head',
		css.row,
	];
	render() {
		return <div className={this.classes.join(' ')}>{this.props.children}</div>;
	}
}
class Cell extends Component {
	static propTypes = {
		head: PropTypes.bool,
		center: PropTypes.bool,
		type: PropTypes.string,
	};
	classes = [
		css.cell,
		this.props.head && css.head,
		this.props.center && css.center,
		css[this.props.type],
	];
	render() {
		return (
			<div onClick={this.props.onClick} className={this.classes.join(' ')}>{this.props.children}</div>
		);
	}
}

export {Table, Row, Cell};



// WEBPACK FOOTER //
// ./src/usersTable/tableUtils.js